/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseFinancialCostCenterViewModel } from "../types/CourseFinancialCostCenterViewModel.ts";

export const courseFinancialCostCenterViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do rateio de centro de custo.")),
  costCenterId: z
    .string()
    .describe("GUID do centro de custo no PecegePay.")
    .nullish(),
  percentage: z.optional(z.number().describe("Percentual do rateio.")),
}) as unknown as ToZod<CourseFinancialCostCenterViewModel>;
